import styles from "./Video.module.css";
import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import PropTypes from "prop-types";

export default function Video({ src }) {
  const videoRef = useRef(null);
  const { ref: containerRef, inView } = useInView({
    threshold: 0.1,
  });
  useEffect(() => {
    if (videoRef.current) {
      if (inView) {
        videoRef.current.play();
      }
    }
  }, [inView]);

  return (
    <div ref={containerRef} className={styles.Video}>
      <video
        ref={videoRef}
        src={src}
        loop
        muted
        playsInline
        width="100%"
        height="100%"
        className={styles.video}
      ></video>
    </div>
  );
}

Video.propTypes = {
  src: PropTypes.string.isRequired,
};
